import { CSSProperties } from "react";

export interface Styles {
  text: CSSProperties;
  imgWrap:CSSProperties;
  img:CSSProperties;
  contentWrap:CSSProperties;
  title:CSSProperties;
  info:CSSProperties;
  careerImgWrap:CSSProperties;
  subTitle:CSSProperties;
  sectionContainer: CSSProperties;
  paragraph: CSSProperties;
  listItem: CSSProperties;
  boldText: CSSProperties;
}


const styles: Styles = {
  sectionContainer: {
    paddingTop: 100,
    paddingBottom: 100,
  },
 
  text: {
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 16,
  },
  
  paragraph: {
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 16,
    marginBottom: 20,
    lineHeight: 1.6,
  },
  
  listItem: {
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 16,
    marginBottom: 10,
    lineHeight: 1.6,
  },
  
  boldText: {
    fontWeight: 600,
  },
  imgWrap:{
    width:180,
    height:180,
    overflow:"hidden",
    marginLeft:"auto",
    marginRight:"auto"
  },
  img:{
    height:"100%",
    width:"100%",
    objectFit:"contain"
  },
  contentWrap:{},
  title:{
    fontFamily: "var(--primary-font-semibold)",
    color: "var(--heading-color)",
    fontSize: 20,
  },
  info:{
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 16,
  },
  careerImgWrap:{
    width:350,
    height:244,
    overflow:"hidden",
    marginLeft:"auto",
    marginRight:"auto"
  },
  subTitle:{
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 12, 
  }
 };

export default styles;
